import React from 'react'
import '../hometabs/HomeTabs.css'
import { Link } from 'react-router-dom'

const SuggestedTabs = () => {
  return (
    
    <div className='tabs-homepage suggested-sec'>
        <div className='tabs-head'>
            <ul className='d-flex flex-wrap justify-content-center'>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li /*className='active-box'*/>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>tom</span>
                </li>
            </ul>
        </div>
        <div className='tabs-bottom-box'>
            <div className='tabs-box  position-relative'>
               <div className='tabs-suggested-box d-flex flex-wrap'>
                     <Link to="/profile-posts-storie" className='tabs-content d-flex flex-wrap align-items-center'>
                        <div className='left-img'></div>
                        <div className='right-box'>
                            <h5>iamtom <span>9h</span></h5>
                            <p>Looking for sugar </p>
                        </div>
                    </Link>
                    <div className='btn-right-follow '>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>Follow</Link>
                        <span className='fire-img'>
                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 11.2857C16 16.4286 12.25 19 8.50001 19C4.74999 19 1 16.4286 1 11.2857C1 7.42858 2.875 5.50001 4.12501 4.85715C4.12501 6.78572 4.75001 8.07144 5.37501 8.7143C9.12502 7.42858 9.75002 3.57143 9.75002 1C12.25 2.92857 16 6.14286 16 11.2857Z" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </span>
                    </div>
               </div>
            </div>
            <div className='tabs-box position-relative'>
                <div className='tabs-suggested-box d-flex flex-wrap '>
                    <Link to="/profile-posts-storie" className='tabs-content d-flex flex-wrap align-items-center'>
                        <div className='left-img'></div>
                        <div className='right-box'>
                            <h5>iamtom <span>9h</span></h5>
                            <p>Who wants money </p>
                        </div>
                    </Link>
                    <div className='btn-right-follow position-relative'>
                        <Link rel='stylesheet' to="/" className='btn btn-border'>Follow</Link>
                    </div>
                </div>
                <div className='two-img-box'>
                    <ul className='d-flex flex-wrap '>
                        <li className='img-box'></li>
                        <li className='img-box'></li>
                    </ul>
                </div>
                
                <span className='fire-img'>
                    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 11.2857C16 16.4286 12.25 19 8.50001 19C4.74999 19 1 16.4286 1 11.2857C1 7.42858 2.875 5.50001 4.12501 4.85715C4.12501 6.78572 4.75001 8.07144 5.37501 8.7143C9.12502 7.42858 9.75002 3.57143 9.75002 1C12.25 2.92857 16 6.14286 16 11.2857Z" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </span>
            </div>
            <div className='tabs-box'>
                <Link to="/profile-posts-storie" className='tabs-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>iamtom <span>9h</span></h5>
                        <p>Dm me</p>
                    </div>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default SuggestedTabs
